// Cómo se llama, en cada rubro, lo que se reserva.
//
// Las palabras las decide el servidor —services/vocabulario.js— y viajan en el
// payload: con el tenant en /api/me para el panel, y con el negocio en la
// página pública de reservas. Acá no se decide nada: se lee.
//
// ─── Por qué no se calcula acá a partir del rubro ──────────────────────────
//
// Porque las mismas palabras salen también por los emails y por los mensajes
// de WhatsApp, que arma el servidor. Con una tabla acá y otra allá, el día que
// se corrija una, la otra queda diciendo lo de antes y nadie se entera hasta
// que un cliente recibe las dos versiones el mismo día.

/**
 * Lo que se usa si el payload no lo trae.
 *
 * Es el vocabulario de siempre, el de personas: durante un despliegue puede
 * haber un navegador con el panel nuevo hablándole a un api viejo, y es
 * preferible que diga «Equipo» a que diga «undefined».
 */
export const POR_DEFECTO = Object.freeze({
  familia: 'persona',
  singular: 'profesional',
  plural: 'profesionales',
  Singular: 'Profesional',
  Plural: 'Profesionales',
  todos: 'Todos los profesionales',
  menu: 'Equipo',
  titulo: 'Tu equipo',
  bajada: 'Quién atiende. Si trabajás solo, sos vos.',
  pendiente: 'cargar tu equipo',
  preguntaPublica: '¿Con quién?',
  bajadaPublica: 'Elegí el profesional.',
  cualquiera: 'Cualquiera',
  cualquieraDetalle: 'El primero que esté libre',
  etiquetaTurno: 'Con',
  ejemploNombre: 'Ej: Juan',
  asistenteBajada: 'Quién atiende. Si trabajás solo, cargate a vos.',
  asignaServicios: true
});

export const vocabularioDe = (fuente) => fuente?.vocabulario ?? POR_DEFECTO;

/** ¿Lo que se reserva es un espacio y no una persona? */
export const esDeCanchas = (vocabulario) => vocabulario?.familia === 'cancha';
